import React from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { useTheme } from '@veneer/theme';

const useStyles = (): Record<'root' | 'pill', SerializedStyles> => {
  const theme = useTheme();
  return React.useMemo(
    () => ({
      root: css({
        boxSizing: 'border-box',
        color: theme.color.foreground.light,
        display: 'block',
        ...theme.typography.captionSmall,
        // 1px extra adds a horizontal scroll
        margin: `0 -7px`,
        padding: `${theme.layout.size2} ${theme.layout.size5} ${theme.layout.size2} ${theme.layout.size5}`,
        position: 'relative',
        userSelect: 'none',

        '&:nth-last-of-type(1)': {
          borderTop: `1px solid ${theme.color.stroke.decorative.default}`,
        },
      }),
      pill: css({
        paddingInline: theme.layout.size6,
      }),
    }),
    [theme]
  );
};

export default useStyles;
